import * as PropTypes from "prop-types";
import {Component} from "react";
import * as React from "react";
import "./IconText.scss";

/**
 * Komponenta ikony s textem (nebo víceřádkovým textem) po levé straně.
 */
class IconText extends Component {

    static propTypes = {
        icon: PropTypes.node,
        text: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
    };

    render() {
        const {icon, text} = this.props;
        const textContent = Array.isArray(text) ? text.map((t, index) => <div key={index}>{t}<br/></div>) : text;
        return (
            <div className="icon-text-wrapper">
                <div className="icon-text-container">
                    {text && <div className="icon-text-text">
                        {textContent}
                    </div>}
                    <div className="icon-text-icon">
                        {icon}
                    </div>
                </div>
            </div>
        )
    }
}

export default IconText;
